<template>
	<v-app id="app">
		<Toolbar />
		<v-content>
			<v-container class="fill-height align-start" fluid>
				<DatabaseSearch />
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import DatabaseSearch from './components/DatabaseSearch.vue';
import Toolbar from './components/Toolbar.vue';


export default {
	name: 'App',
	components: {
		DatabaseSearch,
		Toolbar
	}
};
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;

}
</style>
